import {DataTransferObjectValidation} from "../../../../type/Types";
import {PlaceParticipationPolicyValueObject} from "../../../vo/content/place/PlaceParticipationPolicyValueObject";

export namespace PlaceParticipationPolicyDataTransferObject {
    export type Post = {
        isDefaultValue: boolean | null
        limitedFigure: number | null
        firstFlagLocalTime: string | null
        secondFlagLocalTime: string | null
        allowedAmountMultiplier: number | null
    }

    export namespace Post {
        export const description: Record<keyof Post, string> = PlaceParticipationPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Post> = {
            isDefaultValue(o: string): boolean | null | Error {
                return DataTransferObjectValidation.transformBooleanOrNullIfEmpty(o, 'isDefaultValue')
            },
            limitedFigure(o: string): number | null | Error {
                return DataTransferObjectValidation.transformNumberOrNullIfEmpty(o, 'limitedFigure')
            },
            firstFlagLocalTime(o: string): string | null | Error {
                return DataTransferObjectValidation.validateTimeOrNullIfEmpty(o, 'firstFlagLocalTime')
            },
            secondFlagLocalTime(o: string): string | null | Error {
                return DataTransferObjectValidation.validateTimeOrNullIfEmpty(o, 'secondFlagLocalTime')
            },
            allowedAmountMultiplier(o: string): number | null | Error {
                return DataTransferObjectValidation.transformNumberOrNullIfEmpty(o, 'allowedAmountMultiplier')
            }
        }
    }

    export type Put = {
        isDefaultValue: boolean | null
        limitedFigure: number | null
        firstFlagLocalTime: string | null
        secondFlagLocalTime: string | null
        allowedAmountMultiplier: number | null
    }

    export namespace Put {
        export const description: Record<keyof Put, string> = PlaceParticipationPolicyValueObject.description

        export const validation: DataTransferObjectValidation<Put> = {
            isDefaultValue(o: string): boolean | null | Error {
                return DataTransferObjectValidation.transformBooleanOrNullIfEmpty(o, 'isDefaultValue')
            },
            limitedFigure(o: string): number | null | Error {
                return DataTransferObjectValidation.transformNumberOrNullIfEmpty(o, 'limitedFigure')
            },
            firstFlagLocalTime(o: string): string | null | Error {
                return DataTransferObjectValidation.validateTimeOrNullIfEmpty(o, 'firstFlagLocalTime')
            },
            secondFlagLocalTime(o: string): string | null | Error {
                return DataTransferObjectValidation.validateTimeOrNullIfEmpty(o, 'secondFlagLocalTime')
            },
            allowedAmountMultiplier(o: string): number | null | Error {
                return DataTransferObjectValidation.transformNumberOrNullIfEmpty(o, 'allowedAmountMultiplier')
            }
        }
    }
}